import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get('session_id');

  useEffect(() => {
    const timer = setTimeout(() => navigate('/dashboard'), 4000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9fafb', padding: 24 }}>
      <div style={{ textAlign: 'center', maxWidth: 480 }}>
        <div style={{ fontSize: 64, marginBottom: 24 }}>✓</div>
        <h1 style={{ fontSize: 28, fontWeight: 700, color: '#111', marginBottom: 12 }}>
          Subscription confirmed
        </h1>
        <p style={{ color: '#6b7280', fontSize: 16, lineHeight: 1.6, marginBottom: 32 }}>
          Your 14-day trial is active. You'll receive a receipt by email. Redirecting you to the dashboard…
        </p>
        {sessionId && (
          <p style={{ color: '#9ca3af', fontSize: 12, fontFamily: 'monospace' }}>
            Session: {sessionId}
          </p>
        )}
      </div>
    </div>
  );
}
